/**
 * Edge Types Registry
 *
 * Custom edge types for React Flow.
 * Register edge types here to use them in the canvas.
 */

import type { EdgeTypes } from '@xyflow/react';
import { AppEdge } from './AppEdge';

/**
 * Edge types for React Flow
 *
 * Usage: <ReactFlow edgeTypes={edgeTypes} />
 */
export const edgeTypes: EdgeTypes = {
  // App edge - custom styling for voice app connections
  app: AppEdge,
};

export { AppEdge };
export { EdgeProvider, useEdgeContext } from './EdgeContext';
export { EdgePropertyPopover } from './EdgePropertyPopover';
